(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dash-dedication"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dash-dedication'))customElements.define('dash-dedication',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.pages=[...this.querySelectorAll('.dedication-page')];this.index=0;this.classList.add('dedication-enhanced');this.querySelector('.dedication-controls').hidden=false;this.update();this.querySelector('[data-prev]').addEventListener('click',()=>this.turn(-1));this.querySelector('[data-next]').addEventListener('click',()=>this.turn(1));this.querySelector('.dedication-open').addEventListener('click',()=>this.open());if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.open();this.observer.disconnect()}},{threshold:.05});this.observer.observe(this)}else this.open()}
open(){this.classList.add('dedication-opened');this.querySelector('.dedication-open').hidden=true}
update(){this.pages.forEach((p,i)=>p.hidden=i!==this.index);this.querySelector('[data-page]').textContent=this.index+1;this.querySelector('[data-prev]').disabled=this.index===0;this.querySelector('[data-next]').disabled=this.index===this.pages.length-1}
turn(direction){this.index=Math.max(0,Math.min(this.pages.length-1,this.index+direction));this.update();const page=this.querySelector('.dedication-pages');page.focus({preventScroll:true});page.scrollTop=0}
disconnectedCallback(){if(this.observer)this.observer.disconnect()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dash-ebook-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dash-ebook-slider')) {
customElements.define('dash-ebook-slider', class extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready = true;
this.track = this.querySelector('.dash-ebooks-track');
this.slides = Array.from(this.querySelectorAll('.dash-ebook-slide'));
this.counter = this.querySelector('[data-count]');
this.pauseButton = this.querySelector('[data-pause]');
this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
this.paused = this.motion.matches;
this.index = 0;
const update = () => { this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.play : this.pauseButton.dataset.stop; };
update();
this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1));
this.querySelector('[data-next]').addEventListener('click', () => this.move(1));
this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; update(); });
this.track.addEventListener('scroll', () => {
this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
this.counter.textContent = (this.index + 1) + ' / ' + this.slides.length;
}, {passive:true});
this.timer = window.setInterval(() => {
const rect = this.getBoundingClientRect();
if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement) && rect.bottom > 0 && rect.top < window.innerHeight) this.move(1);
}, 6000);
}
move(direction) {
const next = (this.index + direction + this.slides.length) % this.slides.length;
this.track.scrollTo({left:next * this.track.clientWidth,behavior:this.motion.matches ? 'auto' : 'smooth'});
}
disconnectedCallback() { window.clearInterval(this.timer); this.ready = false; }
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dash-reflection-room"] && !Shopify.designMode) return;
  try {
    (() => {
  function mount(root) {
    if (root.dataset.rrMounted) return;
    root.dataset.rrMounted = 'true';
    const data = JSON.parse(root.querySelector('.rr-data').textContent);
    const dialog = root.querySelector('dialog');
    if (!dialog.showModal) return;
    root.classList.add('rr-ready');
    const find = s => root.querySelector(s);
    const text = (s, value) => { find(s).textContent = value; };
    const drafts = {};
    let key = null, experience = null, draft = null, index = 0, trigger = null;
    const conversation = () => key !== 'self';
    const note = () => draft.notes[index];
    const actualLabel = () => key === 'son' ? data.ui.son_actual : data.ui.partner_actual;
    function showQuestion() {
      const q = experience.questions[index];
      find('.rr-quiz').hidden = false;
      find('.rr-handoff').hidden = true;
      find('.rr-focus').replaceChildren();
      find('.rr-stage').hidden = !conversation();
      if (conversation()) {
        text('.rr-stage', draft.phase === 'predict' ? data.ui.prediction_stage : draft.phase === 'respond' ? data.ui.response_stage : data.ui.review_stage);
        text('#rr-dialog-note', draft.phase === 'respond' ? (key === 'son' ? data.ui.response_intro_son : data.ui.response_intro_partner) : draft.phase === 'review' ? data.ui.review_hint : experience.intro);
      }
      find('.rr-quiz .rr-download').hidden = conversation() && !draft.revealed;
      find('.rr-result').hidden = true;
      find('.rr-error').hidden = true;
      text('.rr-download-status', '');
      text('.rr-progress-text', data.ui.progress.replace('CURRENT', index + 1).replace('TOTAL', experience.questions.length));
      find('.rr-progress').value = index + 1;
      text('.rr-category', q.category);
      text('.rr-question', conversation() && draft.phase === 'respond' ? q.direct : q.question);
      const field = find('.rr-options');
      field.replaceChildren();
      find('.rr-writing').hidden = !conversation();
      find('.rr-self-writing').hidden = conversation();
      if (conversation()) {
        text('.rr-guide-hint', draft.phase === 'respond' ? data.ui.response_hint : draft.phase === 'predict' ? data.ui.prediction_hint : data.ui.review_stage);
        text('.rr-actual-label', draft.phase === 'respond' ? data.ui.your_answer : actualLabel());
        find('#rr-guess').parentElement.hidden = draft.phase === 'respond';
        find('#rr-actual').parentElement.hidden = draft.phase === 'predict';
        find('#rr-actual').placeholder = draft.phase === 'respond' ? data.ui.response_placeholder : '';
        find('#rr-learning').hidden = draft.phase !== 'review';
        find('label[for="rr-learning"]').hidden = draft.phase !== 'review';
        find('#rr-guess').value = draft.phase === 'respond' ? '' : note().guess;
        find('#rr-actual').value = draft.phase === 'predict' ? '' : note().actual;
        find('#rr-learning').value = draft.phase === 'review' ? note().learning : '';
      } else {
        const legend = document.createElement('legend');
        legend.className = 'visually-hidden';
        legend.textContent = q.question;
        field.append(legend);
        q.options.forEach((option, value) => {
          const label = document.createElement('label');
          label.className = 'rr-option';
          const input = document.createElement('input');
          input.type = 'radio'; input.name = 'rr-answer'; input.value = String(value);
          input.checked = draft.answers[index] === value;
          input.addEventListener('change', () => { draft.answers[index] = value; find('.rr-error').hidden = true; });
          const span = document.createElement('span'); span.textContent = option;
          label.append(input, span); field.append(label);
        });
        find('#rr-personal').value = note().personal;
      }
      find('.rr-back').disabled = index === 0;
      text('.rr-next', index === experience.questions.length - 1 ? (conversation() ? (draft.phase === 'predict' ? data.ui.handoff_next : draft.phase === 'respond' ? data.ui.response_finish : data.ui.guide_finish) : data.ui.finish) : data.ui.next);
      find('.rr-question').focus();
    }
    function showHandoff() {
      find('.rr-quiz').hidden = true; find('.rr-result').hidden = true; find('.rr-handoff').hidden = false;
      find('.rr-focus').replaceChildren();
      ['#rr-guess','#rr-actual','#rr-learning'].forEach(selector => { find(selector).value = ''; });
      const ready = draft.phase === 'ready';
      text('.rr-handoff-title', ready ? data.ui.ready_title : data.ui.handoff_title);
      text('.rr-handoff-body', ready ? data.ui.ready_body : data.ui.handoff_body);
      text('.rr-handoff-button', ready ? data.ui.reveal_button : data.ui.handoff_button);
      dialog.scrollTop = 0; find('.rr-handoff-title').focus();
    }
    function paragraph(parent, heading, value) {
      const h = document.createElement('h5'); h.textContent = heading;
      const p = document.createElement('p'); p.textContent = value.trim() || data.ui.blank_note;
      parent.append(h, p);
    }
    function showResults() {
      text('#rr-dialog-note', conversation() ? data.ui.review_hint : experience.intro);
      find('.rr-quiz').hidden = true; find('.rr-result').hidden = false; find('.rr-handoff').hidden = true;
      find('.rr-strength').hidden = true;
      find('.rr-focus').previousElementSibling.hidden = true;
      find('.rr-plan').hidden = !conversation();
      const focus = find('.rr-focus'); focus.replaceChildren();
      if (conversation()) {
        text('.rr-result-title', data.ui.guide_result);
        text('.rr-result-summary', key === 'son' ? data.ui.son_review : data.ui.partner_review);
        find('#rr-plan').value = draft.plan;
        experience.questions.forEach((q, i) => {
          const details = document.createElement('details'); details.className = 'rr-summary-item'; details.open = i === 0;
          const summary = document.createElement('summary'); summary.textContent = q.question; details.append(summary);
          const columns = document.createElement('div'); columns.className = 'rr-summary-columns';
          const guess = document.createElement('div'), actual = document.createElement('div');
          paragraph(guess, data.ui.my_guess, draft.notes[i].guess);
          paragraph(actual, actualLabel(), draft.notes[i].actual);
          columns.append(guess, actual); details.append(columns);
          const learningLabel = document.createElement('label'); learningLabel.htmlFor = 'rr-review-learning-' + i; learningLabel.textContent = data.ui.learning;
          const learningInput = document.createElement('textarea'); learningInput.id = learningLabel.htmlFor; learningInput.rows = 3; learningInput.maxLength = 6000; learningInput.value = draft.notes[i].learning;
          learningInput.addEventListener('input', () => { draft.notes[i].learning = learningInput.value; });
          details.append(learningLabel, learningInput);
          paragraph(details, data.ui.prompt, q.prompt);
          focus.append(details);
        });
      } else {
        const answered = draft.answers.filter(v => v !== null && v !== 4);
        const average = answered.length ? answered.reduce((a, b) => a + b, 0) / answered.length : 0;
        const band = average < 1.1 ? 0 : average < 2.3 ? 1 : 2;
        text('.rr-result-title', answered.length ? experience.results[band] : data.ui.empty_title);
        text('.rr-result-summary', answered.length ? experience.summaries[band] : data.ui.empty_summary);
        const ranked = experience.questions.map((q, i) => ({ ...q, score: draft.answers[i], i })).filter(q => q.score !== null && q.score !== 4).sort((a, b) => a.score - b.score || a.i - b.i);
        ranked.slice(0, 2).forEach(q => {
          const article = document.createElement('article'); article.className = 'rr-insight';
          const h = document.createElement('h5'); h.textContent = q.question;
          const p = document.createElement('p'); p.textContent = q.tip;
          const quote = document.createElement('blockquote'); quote.textContent = q.prompt;
          article.append(h, p, quote);
          if (draft.notes[q.i].personal.trim()) paragraph(article, data.ui.personal_note, draft.notes[q.i].personal);
          focus.append(article);
        });
      }
      dialog.scrollTop = 0; find('.rr-result-title').focus();
    }
    function downloadNotes() {
      if (!experience || (conversation() && !draft.revealed)) return;
      const lines = [experience.title, experience.intro, ''];
      experience.questions.forEach((q, i) => {
        lines.push(String(i + 1) + '. ' + q.question);
        if (conversation()) {
          lines.push(data.ui.my_guess + ':', draft.notes[i].guess || data.ui.blank_note, actualLabel() + ':', draft.notes[i].actual || data.ui.blank_note, data.ui.learning + ':', draft.notes[i].learning || data.ui.blank_note);
        } else {
          const answer = draft.answers[i];
          lines.push(data.ui.written_answer + ':', answer === null ? data.ui.blank_note : q.options[answer], data.ui.personal_note + ':', draft.notes[i].personal || data.ui.blank_note);
        }
        lines.push(data.ui.prompt + ':', q.prompt, '');
      });
      if (conversation()) lines.push(data.ui.shared_plan + ':', draft.plan || data.ui.blank_note);
      try {
        const url = URL.createObjectURL(new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' }));
        const link = document.createElement('a'); link.href = url; link.download = 'reflection-room-' + key + '-notes.txt';
        document.body.append(link); link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(url), 10000);
        text('.rr-download-status', data.ui.downloaded);
      } catch (_) { text('.rr-download-status', data.ui.download_failed); }
    }
    root.querySelectorAll('[data-rr-start]').forEach(button => button.addEventListener('click', () => {
      trigger = button; key = button.dataset.rrStart; experience = data.experiences[key];
      if (!drafts[key]) drafts[key] = { answers: Array(experience.questions.length).fill(null), notes: experience.questions.map(() => ({ guess: '', actual: '', learning: '', personal: '' })), plan: '', phase: 'predict', revealed: false };
      draft = drafts[key]; index = 0;
      dialog.dataset.mode = conversation() ? 'conversation' : 'self';
      text('#rr-dialog-title', experience.title); text('#rr-dialog-note', experience.intro);
      dialog.showModal(); if (conversation() && (draft.phase === 'handoff' || draft.phase === 'ready')) showHandoff(); else if (conversation() && draft.phase === 'done') showResults(); else showQuestion(); dialog.scrollTop = 0;
    }));
    [['#rr-guess', 'guess'], ['#rr-actual', 'actual'], ['#rr-learning', 'learning'], ['#rr-personal', 'personal']].forEach(([selector, property]) => {
      find(selector).addEventListener('input', event => { if (draft) note()[property] = event.target.value; });
    });
    find('#rr-plan').addEventListener('input', event => { if (draft) draft.plan = event.target.value; });
    root.querySelectorAll('.rr-download').forEach(button => button.addEventListener('click', downloadNotes));
    find('.rr-next').addEventListener('click', () => {
      if (!conversation() && draft.answers[index] === null) { find('.rr-error').hidden = false; return; }
      if (index === experience.questions.length - 1) {
        if (conversation() && draft.phase === 'predict') { draft.phase = 'handoff'; showHandoff(); return; }
        if (conversation() && draft.phase === 'respond') { draft.phase = 'ready'; showHandoff(); return; }
        if (conversation()) draft.phase = 'done';
        showResults(); return;
      }
      index++; showQuestion();
    });
    find('.rr-back').addEventListener('click', () => { if (index > 0) { index--; showQuestion(); } });
    find('.rr-handoff-button').addEventListener('click', () => {
      index = 0;
      if (draft.phase === 'ready') { draft.revealed = true; draft.phase = 'done'; showResults(); }
      else { draft.phase = 'respond'; showQuestion(); }
    });
    find('.rr-close').addEventListener('click', () => dialog.close());
    find('.rr-another').addEventListener('click', () => dialog.close());
    find('.rr-restart').addEventListener('click', () => { index = 0; if (conversation()) draft.phase = 'review'; showQuestion(); dialog.scrollTop = 0; });
    dialog.addEventListener('close', () => { if (trigger) trigger.focus(); });
  }
  document.querySelectorAll('.rr-room').forEach(mount);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.rr-room').forEach(mount));
})();
  } catch(e) { console.error(e); }
})();

})();
